import React from 'react';
import { Separator, TypographyMuted } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';

function EndOfListMessage(): React.JSX.Element {
    return (
        <div className="mt-10 flex w-full items-center justify-center px-4">
            <div className="flex w-full max-w-md min-w-64 items-center gap-4">
                <Separator className="flex-1 shrink" />
                <TypographyMuted className="shrink-0">{UIStrings.NoMoreRecruitmentsToShow}</TypographyMuted>
                <Separator className="flex-1 shrink" />
            </div>
        </div>
    );
}

export default EndOfListMessage;
